// TEMPORARY (temp/linked-customer): small chip in the customer list column. Text, not colour alone.
import React from "react";
import { chipFor } from "./linkedLogic";

const LinkedChip = ({ entry }) => {
    const chip = chipFor(entry);
    if (!chip) return <span className="text-muted">-</span>;
    return <span className={`badge rounded-pill text-bg-${chip.tone}`}>{chip.text}</span>;
};

export default LinkedChip;
